/** Heartbeat vazio não pode reabrir o piso: isso devolve colega em reunião como "present". */
export function shouldRejoinVirtualOfficePresence(payload) {
  const status = String(payload?.status || "").trim().toLowerCase();
  return (
    status === "in_other_meeting" ||
    status === "focus" ||
    status === "lunch" ||
    status === "snack" ||
    status === "away"
  );
}
